import { z } from "zod";

export enum RequestMagicLinkMethod {
    Email = 0,
    Sms = 1,
}

export const RequestMagicLinkMethodSchema = z.nativeEnum(RequestMagicLinkMethod);
